export const exampleProject = {
  id: 'example',
  created_at: '2022-10-22T23:21:15.884497-05:00',
  updated_at: '2022-10-22T23:21:15.884497-05:00',
  deleted: false,
  archived: false,
  title: 'Best Practice Project',
  active: true,
  details: 'This is an example template project for best practices',
  state: 3,
  subscription: 1,
  category: 'FES',
  form: {},
  template: true,
  state_r: {
    id: 3,
    name: 'Active',
    deleted: false,
    created_at: '2023-03-22T15:22:12.53011-05:00',
    updated_at: '2023-03-22T15:22:12.53011-05:00',
    subscription: null,
  },
  type_r: null,
  contact_id: '{1}',
  contacts: [
    {
      id: 1,
      role: null,
      role_r: null,
      contact: 1,
      deleted: false,
      project: 1,
      contact_r: {
        id: 1,
        email: 'heesh@centerpiecehq.com',
        deleted: false,
        lastname: 'Naim',
        firstname: 'Heesh',
        created_at: '2022-10-22T23:21:15.89574-05:00',
        updated_at: '2022-10-22T23:21:15.89574-05:00',
      },
      created_at: '2022-10-22T23:21:15.89574-05:00',
      updated_at: '2022-10-22T23:21:15.89574-05:00',
    },
  ],
};

export const exampleProjectItems = [
  {
    id: 11,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 556,
    item: {
      id: 11,
      item: 17386,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 556,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 17386,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 86,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: null,
    coordination: null,
    event: {
      id: 1,
      form: {
        manually: true,
        daterange: [],
      },
      item: 11,
      type: null,
      title: 'Initial Site Measurements',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-25T02:49:27.462511+00:00',
    },
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 12,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 662,
    item: {
      id: 12,
      item: 19404,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 662,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 19404,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 122,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: null,
    coordination: null,
    event: {
      id: 2,
      form: {},
      item: 12,
      type: null,
      title: 'Install Equipment',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 103,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 671,
    item: {
      id: 103,
      item: 19595,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 671,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 19595,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 69,
      created_at: '2023-03-06T00:10:38.439445+00:00',
      updated_at: '2023-03-06T00:10:38.439445+00:00',
    },
    task: {
      id: 101,
      form: {},
      item: 103,
      title: 'Collect Project Documents',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 104,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 673,
    item: {
      id: 104,
      item: 19595,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 673,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 19595,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 69,
      created_at: '2023-03-06T00:10:38.439445+00:00',
      updated_at: '2023-03-06T00:10:38.439445+00:00',
    },
    task: {
      id: 102,
      form: {},
      item: 104,
      title: 'Create Quote',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2023-03-16T17:59:06.2669+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 105,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 677,
    item: {
      id: 105,
      item: 19595,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 677,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 19595,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 69,
      created_at: '2023-03-06T00:10:38.439445+00:00',
      updated_at: '2023-03-06T00:10:38.439445+00:00',
    },
    task: null,
    coordination: {
      id: 103,
      form: {},
      item: 105,
      type: null,
      title: 'Submit Quote',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2023-03-16T17:59:13.447111+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 106,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 684,
    item: {
      id: 106,
      item: 104,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 684,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 104,
      item: 19595,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 673,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: {
      id: 103,
      form: {},
      item: 106,
      title: 'Finalize Markups',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2023-03-22T21:39:56.290631+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 107,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 680,
    item: {
      id: 107,
      item: 104,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 680,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 104,
      item: 19595,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 673,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: {
      id: 104,
      form: {},
      item: 107,
      title: 'Configure Quote',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 108,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 682,
    item: {
      id: 108,
      item: 104,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 682,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 104,
      item: 19595,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 673,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: {
      id: 105,
      form: {},
      item: 108,
      title: 'Install Estimates',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 109,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 679,
    item: {
      id: 109,
      item: 104,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 679,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 104,
      item: 19595,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 673,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: null,
    coordination: {
      id: 104,
      form: {},
      item: 109,
      type: null,
      title: 'Request Pricing from Reps',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 110,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 685,
    item: {
      id: 110,
      item: 104,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 685,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2023-03-22T21:39:50.637495+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 104,
      item: 19595,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 673,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: null,
    coordination: {
      id: 105,
      form: {},
      item: 110,
      type: null,
      title: 'Internal Approvals',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2023-03-22T21:40:00.877685+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 112,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 524,
    item: {
      id: 112,
      item: 17386,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 524,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 17386,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 86,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: {
      id: 107,
      form: {},
      item: 112,
      title: 'Finalize Contract',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 115,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 557,
    item: {
      id: 115,
      item: 17386,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 557,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:00:30.668088+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 17386,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 86,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: null,
    coordination: {
      id: 106,
      form: {},
      item: 115,
      type: null,
      title: 'Approve Shop Drawings',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 116,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 538,
    item: {
      id: 116,
      item: 17386,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 538,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2023-03-16T18:03:26.694181+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 17386,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 86,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: null,
    coordination: {
      id: 107,
      form: {},
      item: 116,
      type: null,
      title: 'Request Shop Drawings',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 122,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 577,
    item: {
      id: 122,
      item: 18981,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 577,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 18981,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 111,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-10T14:43:05.382077+00:00',
    },
    task: {
      id: 110,
      form: {},
      item: 122,
      title: 'Purchase Orders',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 123,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 692,
    item: {
      id: 123,
      item: 122,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 692,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 122,
      item: 18981,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 577,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: {
      id: 111,
      form: {},
      item: 123,
      title: 'Create Orders',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 124,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 693,
    item: {
      id: 124,
      item: 122,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 693,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 122,
      item: 18981,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 577,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: null,
    coordination: {
      id: 113,
      form: {},
      item: 124,
      type: null,
      title: 'Internal Approvals',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 125,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 694,
    item: {
      id: 125,
      item: 122,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 694,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 122,
      item: 18981,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 577,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: {
      id: 112,
      form: {},
      item: 125,
      title: 'Submit Orders and Receive Acknowledgement',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 126,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 575,
    item: {
      id: 126,
      item: 19404,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 575,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 19404,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 122,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: null,
    coordination: null,
    event: {
      id: 101,
      form: {},
      item: 126,
      type: null,
      title: 'Install Walk-ins',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 127,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 549,
    item: {
      id: 127,
      item: 19404,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 549,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 19404,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 122,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: null,
    coordination: null,
    event: {
      id: 102,
      form: {},
      item: 127,
      type: null,
      title: 'Install Hoods',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 128,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 667,
    item: {
      id: 128,
      item: 18709,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 667,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:01:28.960797+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 18709,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 124,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: {
      id: 113,
      form: {},
      item: 128,
      title: 'Finalization',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 129,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 698,
    item: {
      id: 129,
      item: 128,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 698,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 128,
      item: 18709,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 667,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:01:28.960797+00:00',
    },
    task: {
      id: 114,
      form: {},
      item: 129,
      title: 'Punchlist',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 130,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 701,
    item: {
      id: 130,
      item: 127,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 701,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 127,
      item: 19404,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 549,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: null,
    coordination: {
      id: 114,
      form: {},
      item: 130,
      type: null,
      title: 'Job Site Readiness',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-11-17T18:09:35.479846+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 131,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 703,
    item: {
      id: 131,
      item: 126,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 703,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 126,
      item: 19404,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 575,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: null,
    coordination: {
      id: 115,
      form: {},
      item: 131,
      type: null,
      title: 'Job Site Readiness',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 132,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 704,
    item: {
      id: 132,
      item: 12,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 704,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 12,
      item: 19404,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 662,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    task: null,
    coordination: {
      id: 116,
      form: {},
      item: 132,
      type: null,
      title: 'Job Site Readiness',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 133,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 705,
    item: {
      id: 133,
      item: 18709,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 705,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:01:35.769968+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 18709,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 124,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: {
      id: 115,
      form: {},
      item: 133,
      title: 'Close-out Documentation',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 134,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 710,
    item: {
      id: 134,
      item: 128,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 710,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 128,
      item: 18709,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 667,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:01:28.960797+00:00',
    },
    task: null,
    coordination: null,
    event: {
      id: 103,
      form: {},
      item: 134,
      type: null,
      title: 'Demo/Training',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 135,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 711,
    item: {
      id: 135,
      item: 133,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 711,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 133,
      item: 18709,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 705,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:01:35.769968+00:00',
    },
    task: null,
    coordination: {
      id: 117,
      form: {},
      item: 135,
      type: null,
      title: 'Owners Manuals',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 136,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 712,
    item: {
      id: 136,
      item: 133,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 712,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 133,
      item: 18709,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 705,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:01:35.769968+00:00',
    },
    task: null,
    coordination: {
      id: 118,
      form: {},
      item: 136,
      type: null,
      title: 'Warranties',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 137,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 715,
    item: {
      id: 137,
      item: 133,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 715,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 133,
      item: 18709,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 705,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:01:35.769968+00:00',
    },
    task: null,
    coordination: {
      id: 119,
      form: {},
      item: 137,
      type: null,
      title: 'As-Built Drawings',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 139,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 699,
    item: {
      id: 139,
      item: 128,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 699,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 128,
      item: 18709,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 667,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:01:28.960797+00:00',
    },
    task: null,
    coordination: {
      id: 120,
      form: {},
      item: 139,
      type: null,
      title: 'Service Agent List',
      status: 1,
      contact: null,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      start_date: null,
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 17386,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 86,
    item: {
      id: 17386,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 86,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    stage: null,
    grouping: {
      id: 2,
      form: {},
      item: 17386,
      title: 'Project Management',
      status: 'Not Started',
      contact: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 3,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:00:59.469271+00:00',
    },
    parentitem: {
      id: 19635,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 70,
      created_at: '2023-03-06T00:10:40.492704+00:00',
      updated_at: '2023-03-06T00:10:40.492704+00:00',
    },
    task: null,
    coordination: null,
    event: null,
    status: null,
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 18709,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 124,
    item: {
      id: 18709,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 124,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    stage: null,
    grouping: {
      id: 2894,
      form: {},
      item: 18709,
      title: 'Turnover',
      status: 'Not Started',
      contact: 1001,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 18,
      created_at: '2022-12-29T14:01:12.598067+00:00',
      updated_at: '2022-12-29T14:01:39.506313+00:00',
    },
    parentitem: {
      id: 19635,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 70,
      created_at: '2023-03-06T00:10:40.492704+00:00',
      updated_at: '2023-03-06T00:10:40.492704+00:00',
    },
    task: null,
    coordination: null,
    event: null,
    status: null,
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 18981,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 111,
    item: {
      id: 18981,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 111,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-10T14:43:05.382077+00:00',
    },
    stage: null,
    grouping: {
      id: 3,
      form: {},
      item: 18981,
      title: 'Procurement',
      status: 'Not Started',
      contact: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 14,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
    },
    parentitem: {
      id: 19635,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 70,
      created_at: '2023-03-06T00:10:40.492704+00:00',
      updated_at: '2023-03-06T00:10:40.492704+00:00',
    },
    task: null,
    coordination: null,
    event: null,
    status: null,
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 19404,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 122,
    item: {
      id: 19404,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 122,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    stage: null,
    grouping: {
      id: 4,
      form: {},
      item: 19404,
      title: 'Installation',
      status: 'Not Started',
      contact: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 16,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-12-29T14:01:08.95316+00:00',
    },
    parentitem: {
      id: 19635,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 70,
      created_at: '2023-03-06T00:10:40.492704+00:00',
      updated_at: '2023-03-06T00:10:40.492704+00:00',
    },
    task: null,
    coordination: null,
    event: null,
    status: null,
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 19595,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 69,
    item: {
      id: 19595,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 69,
      created_at: '2023-03-06T00:10:38.439445+00:00',
      updated_at: '2023-03-06T00:10:38.439445+00:00',
    },
    stage: {
      id: 1034,
      form: {},
      item: 19595,
      stage: 7,
      contact: null,
      deleted: false,
      outcome: null,
      project: 1,
      stage_r: {
        id: 7,
        name: 'Bid/Quote',
        awarded: false,
        deleted: false,
        created_at: '2023-03-05T23:41:46.628072+00:00',
        updated_at: '2023-03-05T23:41:46.628072+00:00',
        subscription: 1,
      },
      archived: false,
      due_date: null,
      sequence: 0,
      outcome_r: null,
      created_at: '2023-03-06T00:10:38.439445+00:00',
      start_date: null,
      updated_at: '2023-03-06T00:10:38.439445+00:00',
    },
    grouping: null,
    parentitem: null,
    task: null,
    coordination: null,
    event: null,
    status: null,
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 19635,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 70,
    item: {
      id: 19635,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 70,
      created_at: '2023-03-06T00:10:40.492704+00:00',
      updated_at: '2023-03-06T00:10:40.492704+00:00',
    },
    stage: {
      id: 1074,
      form: {},
      item: 19635,
      stage: 8,
      contact: null,
      deleted: false,
      outcome: null,
      project: 1,
      stage_r: {
        id: 8,
        name: 'Build',
        awarded: false,
        deleted: false,
        created_at: '2023-03-05T23:41:46.628072+00:00',
        updated_at: '2023-03-05T23:41:46.628072+00:00',
        subscription: 1,
      },
      archived: false,
      due_date: null,
      sequence: 0,
      outcome_r: null,
      created_at: '2023-03-06T00:10:40.492704+00:00',
      start_date: null,
      updated_at: '2023-03-06T00:10:40.492704+00:00',
    },
    grouping: null,
    parentitem: null,
    task: null,
    coordination: null,
    event: null,
    status: null,
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 20676,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 68,
    item: {
      id: 20676,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 68,
      created_at: '2023-03-10T14:42:41.310492+00:00',
      updated_at: '2023-03-10T14:42:55.575868+00:00',
    },
    stage: {
      id: 1919,
      form: {},
      item: 20676,
      stage: 6,
      contact: 1001,
      deleted: false,
      outcome: null,
      project: 1,
      stage_r: {
        id: 6,
        name: 'Design',
        awarded: false,
        deleted: false,
        created_at: '2023-03-05T23:41:46.628072+00:00',
        updated_at: '2023-03-05T23:41:46.628072+00:00',
        subscription: 1,
      },
      archived: false,
      due_date: null,
      sequence: 0,
      outcome_r: null,
      created_at: '2023-03-10T14:42:41.472153+00:00',
      start_date: null,
      updated_at: '2023-03-10T14:42:41.472153+00:00',
    },
    grouping: null,
    parentitem: null,
    task: null,
    coordination: null,
    event: null,
    status: null,
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 20677,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 716,
    item: {
      id: 20677,
      item: 20676,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 716,
      created_at: '2023-03-10T14:43:14.042036+00:00',
      updated_at: '2023-03-10T14:43:14.042036+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 20676,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 68,
      created_at: '2023-03-10T14:42:41.310492+00:00',
      updated_at: '2023-03-10T14:42:55.575868+00:00',
    },
    task: {
      id: 8640,
      form: {},
      item: 20677,
      title: 'Design Layout',
      status: 1,
      contact: 1001,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2023-03-10T14:43:14.084867+00:00',
      start_date: null,
      updated_at: '2023-03-10T14:43:23.024102+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 21105,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 713,
    item: {
      id: 21105,
      item: 20676,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 713,
      created_at: '2023-03-14T14:29:48.36645+00:00',
      updated_at: '2023-03-16T17:55:07.79217+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 20676,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 68,
      created_at: '2023-03-10T14:42:41.310492+00:00',
      updated_at: '2023-03-10T14:42:55.575868+00:00',
    },
    task: {
      id: 8801,
      form: {},
      item: 21105,
      title: 'Finalize Design Agreement',
      status: 1,
      contact: 1001,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2023-03-14T14:29:48.407316+00:00',
      start_date: null,
      updated_at: '2023-03-16T17:53:58.848314+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 21196,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 537,
    item: {
      id: 21196,
      item: 17386,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 537,
      created_at: '2023-03-16T17:52:42.732589+00:00',
      updated_at: '2023-03-16T17:52:58.168586+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 17386,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 86,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: {
      id: 8837,
      form: {},
      item: 21196,
      title: 'Collect Deposit, if required',
      status: 1,
      contact: 1001,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2023-03-16T17:52:42.779237+00:00',
      start_date: null,
      updated_at: '2023-03-16T17:53:07.58906+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 21197,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 718,
    item: {
      id: 21197,
      item: 20676,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 718,
      created_at: '2023-03-16T17:54:07.44256+00:00',
      updated_at: '2023-03-16T17:55:15.321244+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 20676,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 68,
      created_at: '2023-03-10T14:42:41.310492+00:00',
      updated_at: '2023-03-10T14:42:55.575868+00:00',
    },
    task: {
      id: 8838,
      form: {},
      item: 21197,
      title: 'Finalize Rough-ins',
      status: 1,
      contact: 1001,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2023-03-16T17:54:07.460054+00:00',
      start_date: null,
      updated_at: '2023-03-16T17:54:50.480271+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 21198,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 719,
    item: {
      id: 21198,
      item: 20676,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 719,
      created_at: '2023-03-16T17:55:21.071229+00:00',
      updated_at: '2023-03-16T17:55:21.071229+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 20676,
      item: null,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 68,
      created_at: '2023-03-10T14:42:41.310492+00:00',
      updated_at: '2023-03-10T14:42:55.575868+00:00',
    },
    task: null,
    coordination: {
      id: 7948,
      form: {},
      item: 21198,
      type: null,
      title: 'Final Approval',
      status: 1,
      contact: 1001,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2023-03-16T17:55:21.105836+00:00',
      start_date: null,
      updated_at: '2023-03-16T17:56:53.354854+00:00',
    },
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 21199,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 720,
    item: {
      id: 21199,
      item: 20677,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 720,
      created_at: '2023-03-16T17:57:20.323903+00:00',
      updated_at: '2023-03-16T17:57:20.323903+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 20677,
      item: 20676,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 716,
      created_at: '2023-03-10T14:43:14.042036+00:00',
      updated_at: '2023-03-10T14:43:14.042036+00:00',
    },
    task: {
      id: 8839,
      form: {},
      item: 21199,
      title: 'Create Elevations',
      status: 1,
      contact: 1001,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2023-03-16T17:57:20.343011+00:00',
      start_date: null,
      updated_at: '2023-03-16T17:58:50.884883+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 21200,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 721,
    item: {
      id: 21200,
      item: 20677,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 721,
      created_at: '2023-03-16T17:58:53.475836+00:00',
      updated_at: '2023-03-16T17:58:53.475836+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 20677,
      item: 20676,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 716,
      created_at: '2023-03-10T14:43:14.042036+00:00',
      updated_at: '2023-03-10T14:43:14.042036+00:00',
    },
    task: {
      id: 8840,
      form: {},
      item: 21200,
      title: 'Create Spec Book',
      status: 1,
      contact: 1001,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2023-03-16T17:58:53.496712+00:00',
      start_date: null,
      updated_at: '2023-03-16T17:59:37.256639+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 21201,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 722,
    item: {
      id: 21201,
      item: 20677,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 722,
      created_at: '2023-03-16T17:59:46.801421+00:00',
      updated_at: '2023-03-16T17:59:46.801421+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 20677,
      item: 20676,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 716,
      created_at: '2023-03-10T14:43:14.042036+00:00',
      updated_at: '2023-03-10T14:43:14.042036+00:00',
    },
    task: {
      id: 8841,
      form: {},
      item: 21201,
      title: 'Create CAD/Revit Designs',
      status: 1,
      contact: 1001,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2023-03-16T17:59:46.834729+00:00',
      start_date: null,
      updated_at: '2023-03-16T18:00:48.681401+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
  {
    id: 21202,
    created_at: '0001-01-01T00:00:00Z',
    updated_at: '0001-01-01T00:00:00Z',
    deleted: false,
    archived: false,
    project: 1,
    item_sequence: 523,
    item: {
      id: 21202,
      item: 17386,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 523,
      created_at: '2023-03-16T18:01:18.147893+00:00',
      updated_at: '2023-03-16T18:02:25.030162+00:00',
    },
    stage: null,
    grouping: null,
    parentitem: {
      id: 17386,
      item: 19635,
      deleted: false,
      project: 1,
      archived: false,
      sequence: 86,
      created_at: '2023-03-05T23:37:04.311292+00:00',
      updated_at: '2023-03-05T23:37:04.311292+00:00',
    },
    task: {
      id: 8842,
      form: {},
      item: 21202,
      title: 'Assign Project Management Team',
      status: 1,
      contact: 1001,
      deleted: false,
      details: null,
      project: 1,
      archived: false,
      due_date: null,
      created_at: '2023-03-16T18:01:18.171101+00:00',
      start_date: null,
      updated_at: '2023-03-16T18:02:38.394237+00:00',
    },
    coordination: null,
    event: null,
    status: {
      id: 1,
      name: 'Not Started',
      deleted: false,
      created_at: '2022-10-05T21:43:18.449705+00:00',
      updated_at: '2022-10-05T21:43:18.449705+00:00',
      subscription: null,
    },
    messages: [],
    comments: [],
    relationships: [],
    tags: [],
  },
];
